import { normalize, schema } from 'normalizr';

export const schemaPagination = (key, idAttribute) => {
  return new schema.Entity(
    'pagination',
    { result: [new schema.Entity(key)] },
    { idAttribute: () => idAttribute }
  );
};

export const normalizePagination = params => {
  const { pagination, data, key, idAttribute } = params;

  return normalize(
    { ...pagination, result: data },
    schemaPagination(key, idAttribute)
  );
};



// WEBPACK FOOTER //
// ./src/utils/schema.js